import React from "react";

function HomeScreenTrustedByMillions() {
  return (
    <div className="container" style={{ marginTop: "6rem" }}>
      {/* Trusted by millions */}
      <div className="px-2 text-center">
        <div>
          <label className="display-6 fw-bold">
            The pdf software trusted by millions of users
          </label>
        </div>
        <div className="mt-4">
          <label className="fs-5">
            Shivapdf is your number one web app for editing pdf with ease. Enjoy
            all the tools you need to work efficiently with your digital
            documents while keeping your data safe and secure.
          </label>
        </div>
      </div>
    </div>
  );
}

export default HomeScreenTrustedByMillions;
